import React from 'react';
import { Form } from 'react-bootstrap';

interface Installation {
  id: number;
  name: string;
  description?: string;
}

interface InstallationSelectProps {
  value: number | null;
  installations: Installation[];
  isLoading?: boolean;
  onChange: (installationId: number | null) => void;
}

const InstallationSelect: React.FC<InstallationSelectProps> = ({
    value,
    installations,
    isLoading = false,
    onChange,
}) => {
    const hasInstallations = installations.length > 0;

    return (
        <Form.Select
            value={value ?? ''}
            onChange={(e) => {
                const installationId = e.target.value === '' ? null : Number(e.target.value);
                onChange(installationId);
            }}
            className="flex-grow-1"
            disabled={isLoading}
        >
            <option value="">{isLoading ? 'Loading installations...' : 'Select installation'}</option>
            {!isLoading && !hasInstallations && (
                <option value="" disabled>
                    No installations available
                </option>
            )}
            {installations.map((installation) => (
                <option key={installation.id} value={installation.id}>
                    {`${installation.id}. `}
                    {installation.name}
                    {installation.description && ` (${installation.description})`}
                </option>
            ))}
        </Form.Select>
    );
};

export default InstallationSelect;
